import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import {
  baseDidsInGroup,
  fetchDidsInGroup,
  fetchDidsInGroupFailed,
  fetchDidsInGroupSuccess,
  baseDids,
  fetchDidsGroup,
  fetchDidsGroupSuccess,
  fetchDidsGroupFailed,
  baseDeleteDid,
  fetchDeleteDid,
  fetchDeleteDidSuccess,
  fetchDeleteDidFailed,
  baseReleaseNow,
  fetchReleaseNow,
  fetchReleaseNowSuccess,
  fetchReleaseNowFailed,
  fetchSaveDid,
  fetchSaveDidSuccess,
  fetchSaveDidFailed,
  baseSaveDid,
  loadMoreDidsGroup,
  loadMoreDidsGroupFailed,
  loadMoreDidsGroupSuccess,
  fetchTotalDidInAccount,
  fetchTotalDidInAccountSuccess,
  fetchTotalDidInAccountFailed,
} from 'redux/handleReducers';
import components, { typeUnmounted } from 'consts/components';

const initialState = {
  isProcessingPurchase: false,

  listGroupIsPurchasing: [],
  processes: {},

  errorSearchDid: null,
  errorProcessPurchase: null,
  errorCheckPurchaseAllGroup: null,
  ...baseDeleteDid(),
  ...baseDids(),
  ...baseDidsInGroup(),
  ...baseReleaseNow(),
  ...baseSaveDid(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case types.REQUEST_GET_TOTAL_DID_IN_ACCOUNT:
      return fetchTotalDidInAccount(actions, state);
    case types.REQUEST_GET_TOTAL_DID_IN_ACCOUNT_SUCCESS:
      return fetchTotalDidInAccountSuccess(actions, state);
    case types.REQUEST_GET_TOTAL_DID_IN_ACCOUNT_FAILED:
      return fetchTotalDidInAccountFailed(actions, state);

    case types.REQUEST_SAVE_DID:
      return fetchSaveDid(actions, state);
    case types.REQUEST_SAVE_DID_SUCCESS:
      return fetchSaveDidSuccess(actions, state);
    case types.REQUEST_SAVE_DID_FAILED:
      return fetchSaveDidFailed(actions, state);

    case types.REQUEST_RELEASE_DID_NOW:
      return fetchReleaseNow(actions, state);
    case types.REQUEST_RELEASE_DID_NOW_SUCCESS:
      return fetchReleaseNowSuccess(actions, state);
    case types.REQUEST_RELEASE_DID_NOW_FAILED:
      return fetchReleaseNowFailed(actions, state);

    case types.REQUEST_CHECK_PURCHASE_ALL_GROUP_SUCCESS:
      return {
        ...state,
        listGroupIsPurchasing: actions.listGroupIsPurchasing,
        errorCheckPurchaseAllGroup: null,
      };

    case types.REQUEST_CHECK_PURCHASE_ALL_GROUP_FAILED:
      return {
        ...state,
        errorCheckPurchaseAllGroup: actions.error,
      };

    case types.REQUEST_GET_PURCHASE_PROCESS:
      return {
        ...state,
        isProcessingPurchase: true,
      };

    case types.REQUEST_GET_PURCHASE_PROCESS_SUCCESS:
      return {
        ...state,
        processes: actions.data,
        isProcessingPurchase: false,
        errorProcessPurchase: null,
      };

    case types.REQUEST_GET_PURCHASE_PROCESS_FAILED:
      return {
        ...state,
        errorProcessPurchase: actions.error,
        isProcessingPurchase: false,
      };

    case types.REQUEST_CLEAR_DID_DETAIL: {
      return {
        ...state,
        listDidDetail: [],
      };
    }

    case types.REQUEST_DID_DETAIL: {
      return fetchDidsInGroup(actions, state);
    }

    case types.REQUEST_DID_DETAIL_SUCCESS: {
      return fetchDidsInGroupSuccess(actions, state);
    }

    case types.REQUEST_DID_DETAIL_FAILED: {
      return fetchDidsInGroupFailed(actions, state);
    }

    case types.REQUEST_DELETE_DID: {
      return fetchDeleteDid(actions, state);
    }
    case types.REQUEST_DELETE_DID_SUCCESS: {
      return fetchDeleteDidSuccess(actions, state);
    }

    case types.REQUEST_DELETE_DID_FAILED: {
      return fetchDeleteDidFailed(actions, state);
    }

    case types.REQUEST_LIST_DIDS:
      return fetchDidsGroup(actions, state);

    case types.REQUEST_LIST_DIDS_SUCCESS:
      return fetchDidsGroupSuccess(actions, state);

    case types.REQUEST_LIST_DIDS_FAILED:
      return fetchDidsGroupFailed(actions, state);

    case types.REQUEST_LOAD_MORE_DIDS_GROUP:
      return loadMoreDidsGroup(actions, state);

    case types.REQUEST_LOAD_MORE_DIDS_GROUP_SUCCESS:
      return loadMoreDidsGroupSuccess(actions, state);

    case types.REQUEST_LOAD_MORE_DIDS_GROUP_FAILED:
      return loadMoreDidsGroupFailed(actions, state);

    case typeUnmounted(components.didsDetail):
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
